import { Component, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { AgreementsClient } from '@unity/clients';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { GridDisbursementSharedComponent } from '@unity/shared/grid-disbursement-shared/grid-disbursement-shared.component';
import { QuickActions } from '@unity/utils/quick-actions';

@Component({
  selector: 'unity-list-disbursement-page',
  imports: [PageContainerComponent, GridDisbursementSharedComponent, ActionSharedComponent],
  templateUrl: './list-disbursement-page.component.html',
  styleUrl: './list-disbursement-page.component.scss',
})
export class ListDisbursementPageComponent {
  private readonly agreementsClient = inject(AgreementsClient);

  public readonly $agreementId = input.required({ alias: 'agreementId', transform: (value: string) => parseInt(value) });

  protected readonly $createDisbursementAction = computed(() => {
    const agreementId = this.$agreementId();
    return QuickActions.CreateDisbursement(agreementId);
  });

  protected readonly agreementResource = rxResource({
    params: () => {
      const agreementId = this.$agreementId();
      return agreementId ? { agreementId } : undefined;
    },
    stream: ({ params: { agreementId } }) => this.agreementsClient.getOneAsMini(agreementId),
  });

  protected readonly $agreement = computed(() => (this.agreementResource.hasValue() ? this.agreementResource.value() : undefined));

  protected readonly $contentHeaderSecondary = computed(() => {
    const agreement = this.$agreement();
    return `Agreement: ${agreement?.name}`;
  });

  protected readonly $returnToAgreementAction = computed(() => QuickActions.ReturnToAgreement(this.$agreementId()));
}
